export interface IPanel {
  id: number;
  title: string;
  createdAt: string;
  updatedAt: string;
  allowedProfiles: string;
}

export interface IPanelReport {
  panelId: number;
  reportId: number;
}

export interface ICreatePanelRequest {
  title: string;
  allowedProfiles: string;
}

export interface IUpdatePanelRequest extends ICreatePanelRequest {
  id: number;
}

export interface IAddReportPanelRequest {
  panelId: number;
  reportId: number;
}

export interface IDeleteReportPanelRequest {
  panelId: number;
  reportId: number;
}

export type Config = {
  columns: string;
  reports: any[];
}

export interface Panel extends IPanel {
  config: Config[]
}

export interface PanelDTO extends IPanel {
  config: string;
}